export enum RouteSubType {
  Road = 1,
  MountainBike = 2,
  Cross = 3,
  Trail = 4,
  Mixed = 5,
}
